<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/ip/ip-list' }">访问限制管理</el-breadcrumb-item>
          <el-breadcrumb-item >新增IP访问控制</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="cons-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">新增IP访问控制</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">

            <el-form-item label="起始IP" prop="limit_ip_start" class="error">
              <el-input id="limit_ip_start" v-model="form.limit_ip_start" placeholder="请输入起始IP地址" style="width: 400px;"></el-input>
            </el-form-item>
            <el-form-item label="结束IP" prop="limit_ip_end" class="error">
              <el-input id="limit_ip_end" v-model="form.limit_ip_end" placeholder="请输入结束IP地址" style="width: 400px;"></el-input>
            </el-form-item>

           <!-- <el-form-item label="IP地址范围">
              <div style="display: flex;flex-direction: row;">
                <el-input id="limit_ip_start" v-model="form.limit_ip_start" placeholder="请输入起始IP地址" style="width: 400px;"></el-input>
                <p style="color: #fff;margin-left: 20px;margin-right: 20px;">~</p>
                <el-input id="limit_ip_end" v-model="form.limit_ip_end" placeholder="请输入结束IP地址" style="width: 400px;"></el-input>
              </div>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" class="action-button"  @click="submitForm('form')">立即保存</el-button>
              <!-- @click="submitForm('form')" -->
              <el-button class="action-button" @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </dv-border-box-12>


    </div>

  </div>
</template>

<script>
  export default {
    props: {},
    data() {
      return {
        form: {
          limit_ip_start:'',
          limit_ip_end:'',
        },
        rules: {
          limit_ip_start: [{ required: true, message: '请输入起始IP地址', trigger: 'blur' }],
          limit_ip_end: [{ required: true, message: '请输入结束IP地址', trigger: 'blur' }],
        }
      }
    },
    methods: {
      // 校验IP格式/
      f_check_IP(value,type){
        var ip = value;
        var re=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;//正则表达式
        if(re.test(ip)){
          if( RegExp.$1<256 && RegExp.$2<256 && RegExp.$3<256 && RegExp.$4<256)
          return true;
        }

        if(type == 1){
          this.$message.error("起始IP地址无效！");
        }else{
          this.$message.error("结束IP地址无效！");
        }

        return false;
      },
      submitForm(formName) {
        // if(this.form.limit_ip_start.length == 0){
        //   this.$message.error('请输入起始IP地址');
        //   return;
        // }

        // if(this.f_check_IP(this.form.limit_ip_start,1) == false){
        //   return;
        // }

        // if(this.form.limit_ip_end.length == 0){
        //   this.$message.error('请输入结束IP地址');
        //   return;
        // }

        // if(this.f_check_IP(this.form.limit_ip_end,2) == false){
        //   return;
        // }

        // this.addOneLimit();

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addOneLimit()
          } else {
            return false;
          }
        });
      },
      addOneLimit(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/system/ip/add';
        const data = {
          "startIp":this.form.limit_ip_start,
          'endIp':this.form.limit_ip_end,
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'新增成功',
                type:'success'
              });
              this.resetForm('form');
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    mounted() {
    }
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;


    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }

    .cons-add{
      width: 100%;
      height: 400px;

      .add-form{
        padding: 25px 5px;

        .el-upload-dragger{
          background-color: #1A3F81;
        }

        .el-input__inner{
          float: left;
          background-color: RGBA(17, 58, 113, 0.5);
          border: 2px solid #1D4BB6;
          border-radius: 6px;
          box-shadow: 2px 2px 0 0 rgba(0,0,0,0.2);
          caret-color: rgba(0,255,255,0.8);
          color: #FFFFFF;
          font-size: 15px;
          font-weight: 400;
        }

        //表单验证错误提示偏移
        .el-form-item__error{
          margin-top: -11px;
        }

        .el-descriptions__body{
          // background-color: #00DEFF;
          border: 0px red solid;
        }

        .el-descriptions-item__cell{
          border: 1px #1D4BB6 solid;
        }
          .my-label {
            // background: #E1F3D8;
            background-color: transparent;
            color: rgba(0,255,255,1);
          }

          .my-content {
            // background: #FDE2E2;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }
      }
    }

    // .el-form-item__label{
    //   color: #FFFFFF;
    //   font-size: 18px;
    //   // font-family: Microsoft YaHei;
    //   font-weight: 400;
    // }



  }

</style>



// WEBPACK FOOTER //
// src/view/manage/ip/ip-add.vue